export default {
  name: 'Loading',
  render() {
    return <div>Loading</div>;
  }
};
